import request, { Res } from '@/utils/request'

// OSS Sign
export const getSts = (data: any) => {
  return request.post<Res, Res>(`/xbk_api/api/oss/sts`, data)
}
